module.exports = __webpack_public_path__ + "img/readmore.da248d50.svg";